export default __webpack_public_path__ + "static/media/game_starter.d4de7a45.mp3";